import { render } from "./PrivacyPolicyText.vue?vue&type=template&id=77d67b69&scoped=true"
import script from "./PrivacyPolicyText.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyText.vue?vue&type=script&lang=js"

import "./PrivacyPolicyText.vue?vue&type=style&index=0&id=77d67b69&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d67b69"]])

export default __exports__